(function($){
	$('.category-nav .button').on('click', function() {
		const category = $(this).data('category');
		const section = $(`.category-section[data-cat="${category}"]`);
		const adminBarHeight = $('body').hasClass('admin-bar') && window.matchMedia("(min-width: 783px)").matches
			? $('#wpadminbar').outerHeight()
			: 0;

		$('.category-nav .button').removeClass('is-active');
		$(this).addClass('is-active');

		let offset = section.offset().top;

		offset -= $('.site-header').outerHeight();
		offset -= $('.category-nav').outerHeight();
		offset -= adminBarHeight;

		if (section) {
			$('html, body').animate({
				scrollTop: offset
			}, 400);
		}
	});

	const options = {
		root: null,
		rootMargin: '-40% 0% -60% 0%',
		threshold: 0
	};

	const callback = entries => {
		const isIntersecting = entries.some(entry => entry.isIntersecting);

		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				$('.category-nav .button').removeClass('is-active');
				$(`.category-nav .button[data-category="${entry.target.dataset.cat}"]`).addClass('is-active');
			}
		});

		if (!isIntersecting) {
			$('.category-nav .button').removeClass('is-active');
		}
	};

	let observer = new IntersectionObserver(callback, options);

	let targets = document.querySelectorAll('.category-section');
	targets.forEach(target => {
		observer.observe(target);
	});
})(jQuery);

